import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';



const baseQueryWithReAuth = createBaseQuery('user');


export const webCastUsageApiSlice = createApi({
  reducerPath: 'webCastUsageApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['Usage', 'List'],
  endpoints: (builder) => ({
    getWebcastDropdownData: builder.query({
      query: () => ({
        url: '/get-webcast-data',
        method: 'GET'
      }),
      providesTags: ['List']
    }),
    webcastUsageTable: builder.mutation({
      query: ({ webcastId }) => ({
        url: '/get-webcast-usage',
        method: 'POST',
        body: {
          webcastId
        }
      }),
      invalidatesTags: ['Usage']
    }),
    getWebcastUsersDropdownData: builder.query({
      query: () => ({
        url: '/get-webcast-users-data',
        method: 'GET'
      }),
      providesTags: ['List']
    }),
    webcastUserByName: builder.mutation({
      query: ({ userName }) => ({
        url: '/webcast-user-by-name',
        method: 'POST',
        body: { userName }
      }),
      invalidatesTags: ['Usage']
    }),
    webcastUsageExcel: builder.mutation({
      query: ({ webcastId }) => ({
        url: '/webcast-usage-excel',
        method: 'POST',
        body: { webcastId },
        responseHandler: async (response) => {
          return response.blob();
        },
      }),
    }),
  })
});

export const {
  useGetWebcastDropdownDataQuery,
  useWebcastUsageTableMutation,
  useGetWebcastUsersDropdownDataQuery,
  useWebcastUserByNameMutation,
  useWebcastUsageExcelMutation
} = webCastUsageApiSlice;
